module.exports = "/_next/static/images/Hero@2x-1167a187faec840f649226218536f998.png";